"use client";

import React from "react";
import { Drawer } from "vaul";

import { HeadlineBodyText } from "src/components/KinsaTypography";
import { PaywallProductSelector } from "src/app/paywall/two-prod/components/paywall-product-selector";

import type { PaywallModalContentProps } from "../types";
import { ANALYTICS_EVENTS } from "../constants";

/**
 * Paywall content for the subscription gate modal.
 * Uses the shared PaywallProductSelector component for consistency with the paywall page.
 */
export function PaywallModalContent({
  onStartTrial,
  mode,
}: PaywallModalContentProps) {
  const isModal = mode === "modal";

  return (
    <div className="flex flex-col w-full bg-teal-1000">
      {isModal && (
        <>
          <Drawer.Title className="sr-only">
            Choose your subscription
          </Drawer.Title>
          <Drawer.Description className="sr-only">
            Select a subscription plan to continue
          </Drawer.Description>
        </>
      )}

      <div
        className={`flex flex-col gap-[16px] ${isModal ? "p-[24px] pt-[16px]" : "p-[24px]"}`}
      >
        <HeadlineBodyText className="text-white text-center">
          Choose your plan
        </HeadlineBodyText>

        <PaywallProductSelector
          onContinue={onStartTrial}
          analyticsEventName={ANALYTICS_EVENTS.gateProductSelected}
          analyticsMetadata={{ source: "subscription_gate" }}
        />
      </div>
    </div>
  );
}
